module.exports = __webpack_public_path__ + "img/absenceError.edb257c4.png";